import { ref } from 'vue'

/**
 * 顶部余额"显示冻结"开关（仅 UI 层）
 *
 * 领取奖励时真实余额（store）会立刻更新，但希望顶部数字等收取动画结束再变化：
 *   - hold()    开始冻结：CoinEntry 保持当前显示值不变
 *   - release() 解除冻结：CoinEntry 立即同步到 store 最新值
 * 冻结期间被打断（关闭弹层、离开页面）时只要调用 release，数字就会补齐，不影响真实到账。
 */
const held = ref(false)

export function useCoinDisplayHold() {
  function hold() {
    held.value = true
  }
  function release() {
    held.value = false
  }
  return { held, hold, release }
}
